export const TOAST_TIME_TIME = 3000;

export const COOKIE_TOKEN_KEY = 'xuw_token';